import { component } from "picoapp";
import { ANNOUNCEMENT_BAR_SETTINGS } from "../Carousels/tbsp-carousel--constants";

export const announcementBar = component(async (node: HTMLElement) => {
  const areArrowsVisible = node.dataset.arrowsVisible === "true";

  const [{ default: Splide }] = await Promise.all([
    import("@splidejs/splide"),
    import("@splidejs/splide/css/core"),
  ]);

  const splide = new Splide(node, {
    ...ANNOUNCEMENT_BAR_SETTINGS,
    arrows: areArrowsVisible,
  });
  splide.on("visible", ({ slide }) => {
    slide.classList.remove("absolute", "invisible");
    const splideList = slide.closest(".splide__list");
    if (splideList) {
      splideList.classList.remove("justify-center");
    }
  });
  splide.mount();

  const splideSlides = splide.Components.Slides.get();
  splideSlides.forEach((splideSlide) => {
    const { index, slide } = splideSlide;
    const announcementBarLinks = slide.querySelectorAll("a");
    announcementBarLinks.forEach((link) => {
      link.setAttribute("data-mtr-as", "clickPromoLink");
      link.setAttribute("data-mtr-track", "click");
      link.setAttribute("data-mtr-position", `${index}`);
    });
  });
});
